import React from 'react';

var WebGameColumn = function (_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'left' : _b;
    return React.createElement("div", { className: "".concat(position, "-column") }, children);
};

export { WebGameColumn };
